exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".avatars user-avatar, .avatars .extra {\n  margin-left: -13px;\n  float: left; }\n\n.avatars user-avatar:first-child {\n  margin-left: 0; }\n\n.icon-small {\n  width: 31px;\n  height: 31px; }\n\n.extra {\n  background-color: #5689B3;\n  opacity: 0.9;\n  font-size: 12px; }\n\n.border-white {\n  border: 1px solid #fff; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/common/multiple-user-avatar/multiple-user-avatar.scss
// module id = ../../../../../src/app/components/common/multiple-user-avatar/multiple-user-avatar.scss
// module chunks = 0